<div>
  <mat-toolbar class="toolbar-border">
    {{title}}
  </mat-toolbar>
  <data-table [table]="table" (paginationChange)="fetchTableData()"></data-table>
  <app-authz-access-hint-footer [authzAccessHint]="authzAccessHint"></app-authz-access-hint-footer>
</div>
